import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";

import { UserAuthService } from "src/app/services/userauth.service";

@Injectable()
export class ExamCanActivate implements CanActivate {
  constructor(private userAuthService: UserAuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.userAuthService.checkLogin()) {
      this.router.navigate(["login", next.params.id]);
      return false;
    }
    return true;
  }
}
